import { Link } from "react-router-dom";

export const Logo = ({ className = "" }) => (
  <Link to="/" data-testid="header-logo-link" aria-label="MARKHOR home" className={`group flex shrink-0 items-center gap-3 ${className}`}>
    <img
      src="/img/emblem.png"
      alt=""
      className="h-11 w-11 drop-shadow-[0_6px_10px_rgba(0,0,0,0.25)] transition-transform duration-700 group-hover:rotate-[360deg] md:h-[54px] md:w-[54px]"
    />
    <span className="font-display text-[21px] font-semibold uppercase tracking-[0.34em] md:text-[27px]">Markhor</span>
  </Link>
);
